<template>
  <material-card
  :title="$t('globals.drugs')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="local_hospital"
  >
    <drugs-table :brokerId="brokerId"/>
  </material-card>
</template>

<script>
import DrugsTable from "../components/NewDrugs/DrugsTable";
import { mapGetters } from "vuex";

export default {
  props:["brokerId"],
  components: { DrugsTable },
  computed: {
    ...mapGetters("common", { settings: "settings" }),
  },
  data: () => ({
  }),
  mounted() {
  },
};
</script>
